"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * Accepts a function which is invoked repeatedly
 * with a given interval.
 *
 * @param callback    The function to be invoked.
 * @param delay       The delay between invocations.
 * @param shouldClear Callback fired after every function invocation. The interval is cleared if this function returns true.
 */
function useInterval(callback, delay, shouldClear) {
    if (delay === void 0) { delay = 1000; }
    var savedCallback = react_1.useRef();
    // Remember the latest callback.
    react_1.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    react_1.useEffect(function () {
        var id;
        function tick() {
            // If the interval exists and shouldClear callback
            // is defined and returns true, clear the interval.
            if (id && shouldClear && shouldClear()) {
                clearInterval(id);
            }
            else if (savedCallback.current) {
                // Invoke function
                savedCallback.current();
            }
        }
        id = window.setInterval(tick, delay);
        return function () { return clearInterval(id); };
    }, [shouldClear, delay]);
}
exports.default = useInterval;
//# sourceMappingURL=useInterval.js.map